module.exports = __webpack_public_path__ + "static/twitter-large-750f6218be9dbd8f1834f64bbf007d92.jpg";